import CreateIcon from "@mui/icons-material/Create";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import SaveIcon from "@mui/icons-material/Save";
import { Button, ButtonGroup, Container, IconButton, Paper, Typography } from "@mui/material";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { useContext, useEffect, useState } from "react";
import { v4 } from "uuid";
import { getRoundtableList, updateRoundtables } from "../../api/roundtable";
import { SiteStateContext } from "../../contexts/SiteStateContext";
import { fixSiteState } from "../../util/site_state";
import AdminLayout from "./AdminLayout";

const AdminRoundtable = () => {
    const { setSiteState } = useContext(SiteStateContext);

    const [loading, setLoading] = useState<boolean>(true);
    const [dates, setDates] = useState<RoundTableDate[]>([]);

    useEffect(() => {
        if (setSiteState) {
            setSiteState(fixSiteState({ title: "Roundtable - Admin", navHighlight: "/admin/roundtable", adminPage: true }));
        }
    }, [setSiteState]);

    useEffect(() => {
        getRoundtableList()
            .then((dates) => {
                setDates(dates);
                setLoading(false);
            })
            .catch((err) => {
                console.warn(err);
            });
    }, []);

    return (
        <AdminLayout>
            <Container sx={{ m: 0 }} maxWidth={false}>
                <Typography variant="h2" sx={{ mt: 2, mb: 4 }}>
                    Roundtable
                </Typography>
                <div style={{ display: "flex", margin: "1rem" }}>
                    <ButtonGroup disableElevation variant="outlined" sx={{ marginLeft: "auto" }}>
                        <Button
                            startIcon={<CreateIcon />}
                            onClick={() => {
                                // Default to 7 PM (19:00) on the current date
                                const now = new Date();
                                const defaultDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 19, 0, 0, 0);
                                const newDate: RoundTableDate = {
                                    id: v4(),
                                    dateTime: defaultDate,
                                    deleted: false,
                                };
                                setDates([...dates, newDate]);
                            }}
                        >
                            Add Date
                        </Button>
                        <Button
                            variant="contained"
                            startIcon={<SaveIcon />}
                            onClick={() => {
                                updateRoundtables(dates)
                                    .then((updatedDates) => {
                                        setDates(updatedDates);
                                        console.log("Saved");
                                    })
                                    .catch((err) => {
                                        console.warn(err);
                                    });
                            }}
                        >
                            Save
                        </Button>
                    </ButtonGroup>
                </div>
                {!loading && (
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        {dates.map((date, i) => (
                            <Paper
                                key={date.id}
                                sx={{
                                    p: 2,
                                    display: "flex",
                                    m: 1,
                                }}
                            >
                                <DateTimePicker
                                    value={dayjs(date.dateTime)}
                                    onChange={(val) => {
                                        if (!val) return;
                                        const newDates = [...dates];
                                        newDates[i] = { ...date, dateTime: val.toDate() };
                                        setDates(newDates);
                                    }}
                                    sx={{ width: "100%" }}
                                />
                                <div
                                    style={{
                                        marginLeft: "auto",
                                    }}
                                >
                                    <IconButton
                                        onClick={() => {
                                            const d = dates.filter((d) => d.id !== date.id);
                                            setDates(d);
                                        }}
                                    >
                                        <DeleteForeverIcon />
                                    </IconButton>
                                </div>
                            </Paper>
                        ))}
                    </LocalizationProvider>
                )}
            </Container>
        </AdminLayout>
    );
};

export default AdminRoundtable;
